<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import en from 'element-plus/es/locale/lang/en'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import { loadSiteSettings } from '@/composables/siteSettings'
const { locale } = useI18n()
const componentLocale = computed(() => locale.value === 'en-US' ? en : zhCn)
onMounted(() => { void loadSiteSettings().catch(() => { /* Keep safe defaults; settings page offers retry. */ }) })
</script>
<template><el-config-provider :locale="componentLocale"><router-view /></el-config-provider></template>
